/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCloudPoints = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12 19a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm-2.47-.723-1.06 1.696-2-1.25 1.06-1.696zm8 .446-2 1.25-1.06-1.696 2-1.25zM4 14a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm9 4h-2v-2h2zm7-4a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm-8-3a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm-7 2H3v-2h2zm16 0h-2v-2h2zM9.53 10.277l-1.06 1.696-2-1.25 1.06-1.696zm8 .446-2 1.25-1.06-1.696 2-1.25zM4 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm16 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM9.53 5.723l-2 1.25-1.06-1.696 2-1.25zm8-.446-1.06 1.696-2-1.25 1.06-1.696zM12 1a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCloudPoints as CloudPoints };
